var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.91139C7.53278 3.91139 3.91139 7.53278 3.91139 12C3.91139 16.4672 7.53278 20.0886 12 20.0886C16.4672 20.0886 20.0886 16.4672 20.0886 12C20.0886 7.53278 16.4672 3.91139 12 3.91139ZM3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.82141 17.0125V7.44287H12.991C13.4923 7.44287 13.948 7.57047 14.3581 7.82565C14.7774 8.08085 15.11 8.43173 15.3561 8.87831C15.6022 9.32489 15.7252 9.82617 15.7252 10.3821C15.7252 10.9381 15.6022 11.4393 15.3561 11.8859C15.11 12.3325 14.7774 12.6834 14.3581 12.9386C13.948 13.1938 13.4923 13.3214 12.991 13.3214H9.91509V17.0125H8.82141ZM12.991 12.296C13.4467 12.296 13.8341 12.1183 14.1531 11.7629C14.4721 11.4074 14.6316 10.9472 14.6316 10.3821C14.6316 9.81705 14.4721 9.35679 14.1531 9.00135C13.8341 8.64591 13.4467 8.46819 12.991 8.46819H9.91509V12.296H12.991Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.da2f32c8bae5c8e788e912a0b8d8d07c.svg";
export { ForwardRef as ReactComponent };